import { WizardContextState } from "models/propTypes/wizardPropTypes";
import React, { createContext, PropsWithChildren } from "react";
import { ContextConstants } from "utils/constants";
import { WizardReducer } from "./reducer";

const initialState: WizardContextState = {
  currentStep: 0,
  numOfSteps: 0,
  next: () => {},
  previous: () => {},
  setCurrentStep: () => {},
  setNumOfSteps: () => {},
};

export const WizardContext = createContext<WizardContextState | undefined>(undefined);

const WizardContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = React.useReducer(WizardReducer, initialState);

  const next = () => {
    dispatch({ type: ContextConstants.WizardActions.MOVE_NEXT });
  };

  const previous = () => {
    dispatch({ type: ContextConstants.WizardActions.MOVE_PREV });
  };

  const setCurrentStep = (currentStep: number) => {
    dispatch({ type: ContextConstants.WizardActions.SET_CURRENT_STEP, payload: currentStep });
  };

  const setNumOfSteps = (count: number) => {
    dispatch({ type: ContextConstants.WizardActions.SET_NUMBER_OF_STEPS, payload: count });
  };

  return (
    <WizardContext.Provider value={{ ...state, next, previous, setCurrentStep, setNumOfSteps }}>
      {children}
    </WizardContext.Provider>
  );
};

export default WizardContextProvider;
